import { render, staticRenderFns } from "./OtoTeacherShow.vue?vue&type=template&id=d5be3ab6&scoped=true&"
import script from "./OtoTeacherShow.vue?vue&type=script&lang=js&"
export * from "./OtoTeacherShow.vue?vue&type=script&lang=js&"
import style0 from "./OtoTeacherShow.vue?vue&type=style&index=0&id=d5be3ab6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5be3ab6",
  null
  
)

export default component.exports